import { render, staticRenderFns } from "./IconPlusCircle.vue?vue&type=template&id=32877fa6"
import script from "./IconPlusCircle.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconPlusCircle.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports